import { ChangeEvent, FC } from 'react'

type Props = {
  year: number
  onChange: (year: number) => void
}

const DatepickerHeaderYear: FC<Props> = ({ year, onChange }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    let nextValue = Number(e.target.value)

    if (nextValue === 0) {
      nextValue = new Date().getFullYear()
    }

    onChange(nextValue)
  }

  return (
    <div className="react-datepicker__current-year">
      <input
        type="number"
        className="react-datepicker__year-input"
        value={year}
        onChange={handleChange}
      />
    </div>
  )
}

export { DatepickerHeaderYear }
